import { createContext, useContext } from 'react';

import { GridApi } from '@mint-lib/ag-grid/community';
import { MediaPlan } from '@mint-sdk/api-media-plan';

export type AddRowData = {
  mediaData: MediaPlan.MediaData;
  api: GridApi<MediaPlan.MediaData>;
};

type SetAddRowData = (addRowInfo: AddRowData) => void;

type AddRowDataContextValue = {
  mediaDataId?: string;
  setAddRowData: SetAddRowData;
};

export const AddRowDataContext = createContext<AddRowDataContextValue | null>(
  null,
);

export const useAddRowDataContext = () => {
  const addRowDataContextValue = useContext(AddRowDataContext);

  if (!addRowDataContextValue) {
    throw new Error(
      'useAddRowDataContext must be used within a AddRowProvider',
    );
  }

  return addRowDataContextValue;
};
